module.exports = __webpack_public_path__ + "img/correo.cd7e4553.svg";